import types from './types'

export const postCommentData = (payload) => ({
    type: types.POST_COMMENT, payload
})
export const postCommentDataResp = (payload) => ({
    type: types.POST_COMMENT_RESP, payload
})
export const postCommentDataClear = (payload) => ({
    type: types.POST_COMMENT_CLEAR, payload
})

export const postLikeDisLikeData = (payload) => ({
    type: types.POST_DISLIKE_LIKE_COMMENT, payload
})
export const postLikeDisLikeDataResp = (payload) => ({
    type: types.POST_DISLIKE_LIKE_COMMENT_RESP, payload
})
export const postLikeDisLikeDataClear = (payload) => ({
    type: types.POST_DISLIKE_LIKE_COMMENT_CLEAR, payload
})

export const fetchCommentData = (payload) => ({
    type: types.FETCH_COMMENT, payload
})
export const fetchCommentDataResp = (payload) => ({
    type: types.FETCH_COMMENT_RESP, payload
})
export const fetchCommentDataClear = (payload) => ({
    type: types.FETCH_COMMENT_CLEAR, payload
})

export const postLikeDisLikeProduct = (payload) => ({
    type: types.LIKE_DISLIKE_PRODUCT, payload
})
export const postLikeDisLikeProductResp = (payload) => ({
    type: types.LIKE_DISLIKE_PRODUCT_RESP, payload
})
export const postLikeDisLikeProductClear = () => ({
    type: types.LIKE_DISLIKE_PRODUCT_CLEAR
})